import styled from "styled-components";

export const View = styled.div`
  position: relative;
  height: 100%;
  min-height: 100%;
`;
